/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Actions that can be performed on entities.
 */
export type PermissionAction =
  (typeof PermissionAction)[keyof typeof PermissionAction];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionAction = {
  view: 'view',
  edit: 'edit',
  manage_lifecycle: 'manage_lifecycle',
} as const;
